import React from 'react'
import useSWR from 'swr'
import {withRouter} from 'react-router-dom'
import Fetcher from '../../fetch/fetcher'
import {DataObjectModel} from '../../models'
// State
import {useSelector} from 'react-redux'
import appSlice from '../../store/slices/aplications'
// Components
import {Message} from '../error'
import Loader from '../loader'
import {Input} from 'semantic-ui-react'
import styles from './styles.module.scss'

function DataObjects() {

  const ports = {
    input: {
      id: 'input',
      type: 'left',

    },
    output: {
      id: 'output',
      type: 'right',
    },
  }

  const { data: list, error } = useSWR(`/data-object/list`, Fetcher, {errorRetryCount: 2})

  const handleObjectSearch = () => {

  }

  if (error) {

    const message = error.response
      ? error.response.data.statusMessage
      : 'Something went wrong'

    return (
      <div className={styles.error}>
        <Message negative header={message} />
      </div>
    )
  }

  if (!list) return <Loader />

  const objects = list.data
    ? list.data.map( app => new DataObjectModel(app) )
    : []

  return (
    <div className={styles.content}>

      <Input
        icon="search"
        iconPosition="left"
        placeholder="Search Data Objects"
        className={styles.search}
        onChange={handleObjectSearch}
      />

      <ul className={styles.menu}>
        { objects.map(object => {
          return (
            <li
              key={`data-obj-${object.id}`}
              draggable={true}
              onDragStart={ e => {
                e.dataTransfer.setData('react-flow-chart', JSON.stringify({ type:'data-object', ports, properties:object }))
              } }
              onDragEnd={ e => {
                console.log(e)
              }}
            >
              <div className={styles.type}>{object.type}</div>
              {object.name}
            </li>
          )
        })}
      </ul>
    </div>
  )

}

function ApplicationsSidebar({match}) {

  if (match.params.id) {
    //return DataObjects()
  }

  return false

}

export default withRouter(ApplicationsSidebar)
